"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameCard = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const StyledGameCard_1 = require("./StyledGameCard");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
/**
 * Unboared card component. This component display a clickable card of a game.
 * @param {dict} item - A dictionnary containing informations about the game.
 * @param {boolean} active - If the game is the current selected one.
 */
const GameCard = (_a) => {
    var { size = 100 } = _a, props = __rest(_a, ["size"]);
    const { icon, title, summary, active, disable, style: styleOverride, onPress } = props;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const normalizedSize = normalize(size);
    const height = 1.2 * normalizedSize, width = normalizedSize;
    const cardOpacity = disable ? 0.3 : 1.0;
    const cardStyles = [styles.container, { width: width, height: height, cardOpacity }, styleOverride];
    return (react_1.default.createElement(StyledGameCard_1.StyledGameCard, { active: active, style: cardStyles, onPress: onPress },
        react_1.default.createElement(StyledGameCard_1.StyledGameCardImage, { source: { uri: icon }, size: normalizedSize, disable: disable, active: active }),
        react_1.default.createElement(StyledGameCard_1.StyledGameCardTitle, { type: "h4", text: title, disable: disable, active: active, fontSize: 0.085 * normalizedSize })));
};
exports.GameCard = GameCard;
const styles = react_native_1.StyleSheet.create({
    container: {
    // backgroundColor: 'blue'
    }
});
//# sourceMappingURL=game_card.js.map